import React from 'react';
import {useHistory} from 'react-router-dom';

import * as S from './styles';

import Container from '../../components/Container';

import Content from '../../components/Content';
import CircularButton from '../../components/CircularButton';

import { 
  IoIosArrowBack,
  IoIosArrowForward
} from 'react-icons/io';

function FinalPage() {
  const history = useHistory();

  function backPage(){
    history.push('/anuncio/3');
  }

  return (
      <Container>
        <CircularButton onClick={backPage}><IoIosArrowBack /></CircularButton>
        <Content>
          <S.ColorBg />
        </Content>
        <CircularButton disabled><IoIosArrowForward /></CircularButton>
      </Container>
  );
}

export default FinalPage;